import { useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Pagination({ totalPages, displayCount = 10 }) {
  const location = useLocation();

  const search = new URLSearchParams(location.search);

  const currentPage = parseInt(search.get('page') ?? 1);

  const pageDeps = Math.ceil(currentPage / displayCount - 1) * displayCount;

  const startPage = pageDeps + 1;

  const endPage = Math.min(totalPages - pageDeps, displayCount);

  const pageNumbers = Array.from({ length: endPage }, (_, i) => startPage + i);

  const goToPage = (_page) => {
    search.set('page', _page);
    return { search: search.toString() };
  };

  const handleDisabledClick = useCallback((e, isDisabled) => {
    if (isDisabled) {
      e.preventDefault();
    }
  }, []);

  return (
    <nav className="pagination" aria-label="Page navigation">
      <ul className="pagination__list">
        <li>
          <Link
            to={goToPage(1)}
            className="pagination__first"
            tabIndex={currentPage === 1 ? -1 : 0}
            aria-disabled={currentPage === 1}
            onClick={(e) => handleDisabledClick(e, currentPage === 1)}
          >
            <img src={require('@/assets/images/icon/ico_doubleArrow.svg').default} alt="" width={16} height={16} />
            <span className="sr-only">Go to first page</span>
          </Link>
        </li>
        <li>
          <Link
            to={goToPage(pageDeps - 1)}
            className="pagination__prev"
            tabIndex={currentPage - displayCount < 1 ? -1 : 0}
            aria-disabled={currentPage - displayCount < 1}
            onClick={(e) => handleDisabledClick(e, currentPage - displayCount < 1)}
          >
            <img src={require('@/assets/images/icon/ico_arrow.svg').default} alt="" width={16} height={16} />
            <span className="sr-only">Go to previous page</span>
          </Link>
        </li>
        {pageNumbers.map((num) => (
          <li key={num}>
            <Link
              to={goToPage(num)}
              className="pagination__page"
              tabIndex={currentPage === num ? -1 : 0}
              aria-current={currentPage === num ? 'page' : null}
              onClick={(e) => handleDisabledClick(e, currentPage === num)}
            >
              {num}
            </Link>
          </li>
        ))}

        <li>
          <Link
            to={goToPage(pageDeps + displayCount)}
            className="pagination__next"
            tabIndex={totalPages < currentPage + displayCount ? -1 : 0}
            aria-disabled={totalPages < currentPage + displayCount}
            onClick={(e) => handleDisabledClick(e, totalPages < currentPage + displayCount)}
          >
            <img src={require('@/assets/images/icon/ico_arrow.svg').default} alt="" width={16} height={16} />
            <span className="sr-only">Go to next page</span>
          </Link>
        </li>
        <li>
          <Link
            to={goToPage(totalPages)}
            className="pagination__last"
            tabIndex={totalPages <= currentPage ? -1 : 0}
            aria-disabled={totalPages <= currentPage}
            onClick={(e) => handleDisabledClick(e, totalPages <= currentPage)}
          >
            <img src={require('@/assets/images/icon/ico_doubleArrow.svg').default} alt="" width={16} height={16} />
            <span className="sr-only">Go to last page</span>
          </Link>
        </li>
      </ul>
    </nav>
  );
}
